<template>
  <div id="app">  
    <router-view></router-view>
  </div>
</template>
<script>

export default {
  name: 'app',
}
</script>
<style lang="scss">
	#app {
		height: 100%;
		min-width: 1250px;
	}
	/* 修改弹出框默认样式 */
	.el-message {
	    img {
	        display:none;
	    }
	    .el-message__group {
	        margin: 0;
	        p {
	            margin: 0 auto;
	            color: #fff;
	        }
	    }
	}
	.el-message.success {
		background-color: deepskyblue;
	}
	.el-message.error {
		background-color: pink;
	}
</style>



// WEBPACK FOOTER //
// App.vue?37521556